module.exports = __webpack_public_path__ + "fonts/Pretendard-Regular.7c20008.ttf";